import { Box, Typography } from "@mui/material";
import { getScoreColor } from "../../utils/utils";


interface RelevanceSidebarProps {
  relevanceScoreData: { id: number; score: number; name: string; image: string }[];
  handleActiveClick: (id: number) => void;
  activeId: number | null;
}

const RelevanceSidebar = ({
  relevanceScoreData,
  handleActiveClick,
  activeId,
}: RelevanceSidebarProps) => {
  return (
    <Box>
      {relevanceScoreData.map((item, index) => (
        <Box key={item.id} display={"flex"} gap={1.5} alignItems={"center"}>
          <Box sx={{ width: "25px" }}>
            <Typography
              variant="caption"
              fontWeight={400}
              sx={{ color: "#00000061" }}
            >
              {item.score}%
            </Typography>
          </Box>
          <Box
            sx={{
              width: "17px",
              height: "57px",
              bgcolor: getScoreColor("#205B5B", item.score),
              borderTopLeftRadius: index === 0 ? "100px" : 0,
              borderTopRightRadius: index === 0 ? "100px" : 0,
              borderBottomLeftRadius:
                index === relevanceScoreData.length - 1 ? "100px" : 0,
              borderBottomRightRadius:
                index === relevanceScoreData.length - 1 ? "100px" : 0,
            }}
          />
          <Box
            display={"flex"}
            gap={1}
            alignItems={"center"}
            sx={{
              ":hover": {
                bgcolor: "#ffffff",
              },
              transition: "all 0.3s ease",
              width: "134px",
              borderRadius: 0.75,
              padding: "10px 16px",
              cursor: "pointer",
              bgcolor: activeId === item.id ? "#ffffff" : undefined,
            }}
            onClick={() => handleActiveClick(item.id)}
          >
            <Box
              sx={{
                width: 24,
                height: 24,
                borderRadius: 0.5,
                overflow: "hidden",
              }}
            >
              <img
                src={`../icons/${item.image}.png`}
                alt={item.image}
                loading="lazy"
              />
            </Box>

            <Typography
              variant="body2"
              fontWeight={500}
              sx={{ color: "#00000099" }}
            >
              {item.name}
            </Typography>
          </Box>
        </Box>
      ))}
    </Box>
  );
};

export default RelevanceSidebar;